import React, { useEffect, useState } from "react";
import { Bar, Pie, Line } from "react-chartjs-2";
import axiosInstance from "../../../../axios";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Loading } from "../../../Other/Loading";

export default function Charts() {
  const [pendingApproval, setPendingApproval] = useState({});
  const [loading, setloading] = useState(true);
  function fetch() {
    axiosInstance
      .get("admin/statistics")
      .then((res) => {
        setPendingApproval(res?.data?.data?.pendingApprovals);
        setloading(false);
      })
      .catch((error) => console.log(error));
  }

  useEffect(() => {
    fetch();
  }, []);

  const data = {
    labels: ["Courses for Category", "Pending Students", "Pending Instructors"],
    datasets: [
      {
        data: [
          pendingApproval?.courses,
          pendingApproval?.students,
          pendingApproval?.teachers,
        ],
        backgroundColor: [
          "rgba(39, 134, 157,1)",
          "rgba(91, 5, 150,1)",
          "rgba(8,207, 255,1)",
        ],
        borderWidth: 0,
      },
    ],
  };

  const options = {
    maintainAspectRatio: false,
    responsive: true,
    plugins: {
      legend: {
        position: "right",
        labels: {
          usePointStyle: true,
          pointStyle: "circle",
          font: {
            size: 10,
            weight: 600,
          },
        },
      },
    },
  };

  return (
    <div id="myChart">
      {loading ? (
        <Loading />
      ) : (
        <Pie data={data} options={options} height={76} width={75} />
      )}
    </div>
  );
}

export const DashboardLine = ({ chartTitle, instructor }) => {
  ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend
  );
  const [pendingApproval, setPendingApproval] = useState([]);
  const [loading, setloading] = useState(true);
  function fetch() {
    {
      instructor
        ? axiosInstance
            .get("instructor/statistics")
            .then((res) => {
              setPendingApproval(res?.data?.data?.enrollmentsByMonths);
              setloading(false);
            })
            .catch((error) => console.log(error))
        : axiosInstance
            .get("admin/statistics")
            .then((res) => {
              setPendingApproval(res?.data?.data?.userTypeByMonths);
              setloading(false);
            })
            .catch((error) => console.log(error));
    }
  }

  useEffect(() => {
    fetch();
  }, []);

  const getmonth = pendingApproval?.map((ele) => {
    const d = new Date();
    d.setMonth(ele?.monthNumber - 1);
    const monthName = d.toLocaleString("default", { month: "short" });
    return monthName;
  });

  const data = instructor
    ? {
        labels: getmonth,
        datasets: [
          {
            label: "Students",
            data: pendingApproval?.map((ele) => ele?.total),
            backgroundColor: "rgba(39, 134, 157,1)",
            categoryPercentage: 0.2,
            borderRadius: Number.MAX_VALUE,
            borderSkipped: false,
          },
        ],
      }
    : {
        labels: getmonth,
        datasets: [
          {
            label: "Students",
            data: pendingApproval?.map((ele) => ele?.students),
            backgroundColor: "rgba(39, 134, 157,1)",
            categoryPercentage: 0.2,
            borderRadius: Number.MAX_VALUE,
            borderSkipped: false,
          },
          {
            label: "Instructors",
            data: pendingApproval?.map((ele) => ele?.teachers),
            backgroundColor: "rgba(53, 162, 235, 0.5)",
            categoryPercentage: 0.2,
            borderRadius: Number.MAX_VALUE,
            borderSkipped: false,
          },
        ],
      };

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: "bottom",
        labels: {
          usePointStyle: true,
          pointStyle: "circle",
          font: {
            size: 6,
          },
        },
      },
      title: {
        display: true,
        text: chartTitle,
        font: {
          size: 10,
        },
      },
    },
    scales: {
      x: {
        grid: {
          color: "white",
          borderColor: "white",
        },
        ticks: {
          font: {
            size: 8,
          },
        },
      },
      y: {
        grid: {
          color: "white",
          borderColor: "white",
        },
        ticks: {
          font: {
            size: 8,
          },
        },
      },
    },
  };

  return (
    <div id="myChart-1">
      {loading ? (
        <Loading />
      ) : (
        <Bar
          data={data}
          options={options}
          width="30%"
          height={instructor ? "15%" : "40%"}
        />
      )}
    </div>
  );
};

export const DashboardSchool = ({ chartTitle, instructor }) => {
  const [webinarData, setWebinarData] = useState([]);
  const [loading, setloading] = useState(true);

  function fetch() {
    instructor &&
      axiosInstance
        .get("instructor/statistics")
        .then((res) => {
          setWebinarData(res?.data?.data?.webinarsByMonths);
          setloading(false);
        })
        .catch((error) => console.log(error));
  }

  useEffect(() => {
    fetch();
  }, []);

  const getmonth = webinarData?.map((ele) => {
    const d = new Date();
    d.setMonth(ele?.monthNumber - 1);
    const monthName = d.toLocaleString("default", { month: "short" });
    return monthName;
  });

  const data = {
    labels: getmonth,
    datasets: [
      {
        fill: true,
        lineTension: 0.4,
        label: instructor ? "" : "schools",
        data: instructor ? webinarData.map((ele) => ele.total) : [],
        backgroundColor: instructor ? "#e8f6fa" : "rgba(239, 215, 250, 1)",
        borderColor: instructor ? "#147AD6" : "#c172f6",
        pointRadius: 1,
      },
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: "bottom",
        labels: !instructor && {
          usePointStyle: true,
          pointStyle: "circle",
          font: {
            size: 6,
          },
        },
      },
      title: {
        display: true,
        text: chartTitle,
        font: {
          size: 8,
        },
      },
    },
    scales: {
      x: {
        grid: {
          color: "white",
          borderColor: "white",
        },
        ticks: {
          font: {
            size: 10,
          },
        },
      },
      y: {
        grid: {
          color: "white",
          borderColor: "white",
        },
        ticks: {
          font: {
            size: 8,
          },
        },
      },
    },
  };

  return (
    <>
      {loading && instructor ? (
        <Loading />
      ) : (
        <Line
          options={options}
          data={data}
          width="30%"
          height={instructor ? "15%" : "40%"}
        />
      )}
    </>
  );
};

export const DashboardCombineChart = ({ instructor }) => {
  const labels = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  const data = {
    labels,
    datasets: instructor
      ? [
          {
            type: "line",
            label: " Revenue",
            borderColor: "#27869d",
            backgroundColor: "#27869d",
            data: [23, 24, 55, 43, 13, 34, 56, 78, 45, 33, 56, 65],
          },
          {
            type: "line",
            label: "Student",
            backgroundColor: "#f70fc5",
            borderColor: "#f70fc5",
            data: [23, 45, 34, 34, 54, 23, 67, 87, 65, 56, 87, 66],
          },
        ]
      : [
          {
            type: "line",
            label: "Instructor Revenue",
            borderColor: "#27869d",
            backgroundColor: "#27869d",
            data: [23, 24, 55, 43, 13, 34, 56, 78, 45, 33, 56, 65],
          },
          {
            type: "line",
            label: "Student Revenue",
            backgroundColor: "#f70fc5",
            borderColor: "#f70fc5",
            data: [23, 45, 34, 34, 54, 23, 67, 87, 65, 56, 87, 66],
          },
          {
            type: "bar",
            label: "Actual Revenue",
            backgroundColor: "#d9e4e6",
            data: [34, 56, 43, 23, 45, 23, 45, 78, 90, 53, 34, 65],
            borderRadius: 3,
            categoryPercentage: 0.7,
          },
        ],
  };

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: "bottom",
        labels: {
          usePointStyle: true,
          pointStyle: "circle",

          font: {
            size: 10,
            weight: 600,
          },
        },
      },
    },
    scales: {
      x: {
        grid: {
          color: "white",
          borderColor: "white",
        },
        ticks: {
          font: {
            size: 8,
          },
        },
      },
      y: {
        ticks: {
          font: {
            size: 8,
          },
        },
      },
    },
  };

  return (
    <Bar
      type="bar"
      data={data}
      options={options}
      height={instructor ? "210px" : "204px"}
    />
  );
};
